import { api } from "../lib/api";
import { useAsync } from "../lib/useAsync";
import { Page, Card, Bar, RichLoader, ErrorBox, UpdatedAt } from "../components/ui";
import { useDelayedFlag } from "../lib/useDelayedFlag";
import { useWaitMessage } from "../lib/useWaitMessage";
import { flag } from "../lib/flag";
import { useT } from "../i18n";

const MEDALS = ["🥇", "🥈", "🥉"];

export default function Leaderboard() {
  const t = useT();
  const { data, loading, error } = useAsync(() => api.leaderboard(), []);
  const showRich = useDelayedFlag(loading, 400);
  const waitKey = useWaitMessage(loading);

  return (
    <Page>
      <h1 className="text-xl font-semibold mb-1">🗳️ {t("leaderboard.title")}</h1>
      <p className="text-muted text-sm mb-5">{t("leaderboard.blurb")}</p>

      {showRich && <RichLoader headline={t("leaderboard.computing")} message={t(waitKey)} />}
      {error && <ErrorBox msg={error} />}

      {data && <UpdatedAt ms={data.updatedAt} />}

      {data && (
        <Card className="p-0 overflow-hidden">
          {data.rows.map((r, i) => (
            <div
              key={r.countryId}
              className="grid grid-cols-[28px_1fr_92px_52px] sm:grid-cols-[36px_1fr_110px_70px] gap-2 sm:gap-3 items-center px-4 py-3.5 border-b border-border last:border-0"
            >
              <div className="text-center font-bold text-muted">{MEDALS[i] ?? i + 1}</div>
              <div className="min-w-0">
                <div className="flex items-center gap-2.5">
                  <span className="text-2xl">{flag(r.countryCode)}</span>
                  <div className="min-w-0">
                    <div className="font-semibold truncate">{r.countryName}</div>
                    <div className="text-xs text-muted capitalize">{r.electionType === "president" ? t("office.president") : t("office.congress")}</div>
                  </div>
                </div>
                <Bar pct={r.turnoutPct} color="#22c55e" />
              </div>
              <div className="text-right">
                <div className="font-bold tabular-nums">{r.turnoutPct}%</div>
                <div className="text-[11px] text-muted">
                  {r.voted}/{r.eligible}
                </div>
              </div>
              <div className="text-right text-sm text-muted tabular-nums">
                <b className="text-warn">{r.abstentionPct}%</b>
              </div>
            </div>
          ))}
          {data.rows.length === 0 && (
            <div className="text-muted text-sm p-4">{t("leaderboard.empty")}</div>
          )}
        </Card>
      )}
    </Page>
  );
}
